import { ReactNode, ReactText } from "react"
import { css, cx } from "@emotion/css"

const styles = {
  root: css`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
  `,
  primary: css`
    white-space: nowrap;
    display: inline;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  secondary: css`
    margin-left: 4px;
    margin-left: 1ch;
  `,
}

export type CheckListItemLabelProps = {
  primary: ReactNode
  secondary?: ReactText
  className?: string
}

export function CheckListItemLabel(props: CheckListItemLabelProps) {
  const { className, primary, secondary } = props
  return (
    <div className={cx("BodyBody-2BlackLight", styles.root, className)}>
      <div className={styles.primary}>{primary}</div>
      <span className={cx("BodyBody-2Dark-greyRegular", styles.secondary)}>
        {secondary}
      </span>
    </div>
  )
}
